import React, { useState, useEffect, useMemo, useCallback } from 'react';
import axios from 'axios';
import './App.css';

function App() {
  const [showAddForm, setShowAddForm] = useState(false);

  const [songs, setSongs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [newSong, setNewSong] = useState({ 
    author: '', 
    title: '', 
    lyrics: '',
    category: '',
    approved: false
  });

  // Add function to fetch categories
  const fetchCategories = useCallback(async () => {
    try {
      const response = await axios.get('http://localhost/api/songs.php?type=categories');
      setCategories(response.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  }, []);

  // Remove the isAdmin state
  const [visibleLyrics, setVisibleLyrics] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [addedSongTitle, setAddedSongTitle] = useState('');

  const songsPerPage = 8;

  const fetchSongs = useCallback(async () => {
    try {
      const response = await axios.get('https://tononkira.flm-rff.org/api/songs.json');
      const songsArray = Array.isArray(response.data) ? response.data : [response.data];
      console.log('Fetched songs:', songsArray);
      setSongs(songsArray);
      setError(null);
    } catch (error) {
      setError('Erreur de connexion au serveur.');
      console.error('Error fetching songs:', error);
    }
  }, []);

  useEffect(() => {
    fetchSongs();
    fetchCategories();
  }, [fetchSongs, fetchCategories]);

  const filteredSongs = useMemo(() => 
    songs.filter(song => 
      song.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      song.author.toLowerCase().includes(searchTerm.toLowerCase())
    ), 
    [songs, searchTerm]
  );

  // Update displayedSongs to only show approved songs
  const displayedSongs = useMemo(() => 
    filteredSongs.filter(song => song.approved === true), 
    [filteredSongs]
  );

  const indexOfLastSong = currentPage * songsPerPage;
  const indexOfFirstSong = indexOfLastSong - songsPerPage;
  const currentSongs = useMemo(() => 
    displayedSongs.slice(indexOfFirstSong, indexOfLastSong), 
    [displayedSongs, indexOfFirstSong, indexOfLastSong]
  );

  const totalPages = Math.ceil(displayedSongs.length / songsPerPage);

  const toggleLyrics = (index) => {
    setVisibleLyrics(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const songData = {
        author: newSong.author,
        title: newSong.title,
        lyrics: newSong.lyrics,
        category: newSong.category,
        approved: false
      };
      
      // Sauvegarde du titre pour l'utiliser dans le message de succès
      const songTitle = newSong.title;
      const songAuthor = newSong.author;
      
      const response = await axios.post('https://tononkira.flm-rff.org//api/songs.php', songData);
      
      setAddedSongTitle(songTitle);
      setSuccessMessage(
        response.data?.message || 
        `Misaotra indrindra amin'ny fandraisana anjara! Nampidirina soa aman-tsara ny hira "${songTitle}" avy amin'i ${songAuthor}. Hojerena sy hampidirina amin'ny lisitra ny hiranao afaka fotoana fohy.`
      );
      
      setNewSong({ 
        author: '', 
        title: '', 
        lyrics: '', 
        category: '',
        approved: false 
      });
      
      fetchSongs();
      setShowAddForm(false);
      
      // Le message disparaîtra après 8 secondes au lieu de 5
      setTimeout(() => setSuccessMessage(null), 8000);
    } catch (error) {
      console.error('Error adding song:', error);
      setError('Erreur lors de l\'ajout de la chanson');
    }
  };

  return (
    <div className="App">
      <header className="app-header">
        <div className="header-content">
          <h1>Tononkira Loterana</h1>
          <p className="app-description">
            Miarahaba anao amin'ny anaran'i Jesosy Kristy. Tongasoa eto amin'ny Pejy tononkira.flm-rff.org ity 
            Natao ity tranokala ity mba hanangonana sy hitehirizantsika ireo hiran'ny antokom-pihira na fiangonana izay fihira ao amin'ny fiangonana Loterana Malagasy, ary natao ho zaraina ihany koa ireo hira ireo ho antsika rehetra. Koa raha mahalala hira ireny ianao, dia asaina hampiditra azy eto.
          </p>
        </div>
        <div className="header-right">
          <div className="download-section">
            <h3>Telechargeo ny applicationtsika</h3>
            <p>KoloMpanahy - isan'ny ahafahanao mijery ireo tononkira ato amin'ity tranokala ity</p>
            <div className="download-buttons">
              <a href="#" className="download-link">
                <img src="/images/app-store.png" alt="Télécharger sur l'App Store" />
              </a>
              <a href="#" className="download-link">
                <img src="/images/play-store.png" alt="Disponible sur Google Play" />
              </a>
            </div>
          </div>
        </div>
      </header>

      <div className="content-wrapper">
        <div className="songs-section">
          <div className="songs-header">
            <h2>
              Ireo hira misy ({displayedSongs.length})
            </h2>
            <button 
              className="add-btn"
              onClick={() => setShowAddForm(!showAddForm)}
              title={showAddForm ? 'Fermer le formulaire' : 'Hampiditra hira vaovao'}
            >
              <span className="add-btn-icon">{showAddForm ? '×' : '+'}</span>
              <span className="add-btn-text">{showAddForm ? 'Akatona' : 'Hampiditra hira'}</span>
            </button>
          </div>

          {/* Message de succès amélioré */}
          {successMessage && (
            <div className="success-message-global">
              <div className="success-message-content">
                <span className="success-icon">✓</span>
                <p>{successMessage}</p>
              </div>
              <button onClick={() => setSuccessMessage(null)} className="close-message-btn">×</button>
            </div>
          )}

          {showAddForm && (
            <div className="modal-overlay">
              <div className="modal-content">
                <div className="modal-header">
                  <h2>Hampiditra hira</h2>
                  <button className="close-btn" onClick={() => setShowAddForm(false)}>×</button>
                </div>
                <form onSubmit={handleSubmit}>
                  {/* Replaced select with input for category */}
                  <div>
                    <input
                      type="text"
                      placeholder="Sokajy (ohatra: FANEVA , Ireo SAMPANA MISY sns.)"
                      value={newSong.category}
                      onChange={(e) => setNewSong({...newSong, category: e.target.value})}
                      required
                      list="category-suggestions"
                    />
                    {/* Optional datalist for suggestions */}
                    <datalist id="category-suggestions">
                      {categories.map((cat, index) => (
                        <option key={index} value={cat} />
                      ))}
                    </datalist>
                  </div>
                  <div>
                    <input
                      type="text"
                      placeholder="Mpihira azy"
                      value={newSong.author}
                      onChange={(e) => setNewSong({...newSong, author: e.target.value})}
                      required
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      placeholder="Lohateny"
                      value={newSong.title}
                      onChange={(e) => setNewSong({...newSong, title: e.target.value})}
                      required
                    />
                  </div>
                  <div>
                    <textarea
                      placeholder="Tononkira rehetra..."
                      value={newSong.lyrics}
                      onChange={(e) => setNewSong({...newSong, lyrics: e.target.value})}
                      required
                    />
                  </div>
                  <button type="submit">Hampiditra</button>
                </form>
              </div>
            </div>
          )}

          <div className="search-container">
            <input
              type="text"
              placeholder="Hitady hira..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
              className="search-input"
            />
          </div>
          
          <div className="songs-list">
              {error ? (
                <p className="error-message">{error}</p>
              ) : currentSongs && currentSongs.length > 0 ? (
                currentSongs.map((song, index) => (
                  <div key={song._id || index} className="song-card">
                    <h3>{song.title}</h3>
                    <p><strong>Auteur :</strong> {song.author}</p>
                    <p><strong>Catégorie :</strong> {song.category}</p>
                    <p><strong>Statut :</strong> {song.approved ? 'Approuvé' : 'En attente'}</p>
                    <button 
                      className="toggle-btn"
                      onClick={() => toggleLyrics(song._id || index)}
                    >
                      {visibleLyrics[song._id || index] ? 'Hanafina ny tononkira' : 'Hijery ny tononkira'}
                    </button>
                    {visibleLyrics[song._id || index] && (
                      <p className="lyrics">{song.lyrics}</p>
                    )}
                  </div>
                ))
              ) : (
                <p>Tsy misy ireo hira</p>
              )}
            </div>

          {displayedSongs.length > songsPerPage && (
            <div className="pagination">
              <button 
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
                className="page-btn"
              >
                Précédent
              </button>
              
              <div className="page-numbers">
                {Array.from({ length: totalPages }, (_, i) => (
                  <button
                    key={i + 1}
                    onClick={() => paginate(i + 1)}
                    className={`page-btn ${currentPage === i + 1 ? 'active' : ''}`}
                  >
                    {i + 1}
                  </button>
                ))}
              </div>

              <button 
                onClick={() => paginate(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="page-btn"
              >
                Suivant
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;